var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 450 450",
    height: 512,
    viewBox: "0 0 450 450",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m365 435h-280c-38.598 0-70-31.401-70-70v-280c0-38.598 31.402-70 70-70h280c38.599 0 70 31.402 70 70v280c0 38.599-31.401 70-70 70zm-280-400c-27.57 0-50 22.43-50 50v280c0 27.57 22.43 50 50 50h280c27.57 0 50-22.43 50-50v-280c0-27.57-22.43-50-50-50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.561 315.2c-.039 0-.077 0-.115-.001-4.035-.046-7.646-2.513-9.157-6.253l-56.126-138.93-27.038 58.744c-1.632 3.547-5.18 5.819-9.084 5.819h-48.6c-5.523 0-10-4.478-10-10 0-5.523 4.477-10 10-10h42.194l34.042-73.961c1.668-3.625 5.324-5.912 9.321-5.816 3.989.094 7.54 2.552 9.035 6.251l55.826 138.186 25.079-58.198c1.58-3.667 5.19-6.042 9.184-6.042h46.439c5.522 0 10 4.477 10 10 0 5.522-4.478 10-10 10h-39.861l-31.957 74.157c-1.581 3.671-5.194 6.044-9.182 6.044z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/activities.ecfb286c10656e62e203b74dffb32d06.svg";
export { ForwardRef as ReactComponent };